import * as graphql from 'generated/graphql';
import SidebarConversationSection from './ConversationSection';
import SidebarGoalsSection from './GoalsSection';
import SidebarFeedbackSection from './FeedbackSection';
import SidebarComplimentSection from './ComplimentSection';
import SidebarNotesSection from './NotesSection';
import useFeature from 'packages/kakapo-ui-application/hooks/useFeature';
import SidebarJobsSection from './JobsSection';
import { useTranslation } from 'react-i18next';
import { Box, Drawer } from '@mantine/core';
import { Button } from '@treams/treams-ui';
import styled, { css } from 'styled-components';
import { useDisclosure } from '@mantine/hooks';
import { ChevronLeftIcon } from '@treams/treams-icons';

const SideFloatingButton = styled(Button)<{ open?: boolean }>`
	position: fixed;
	top: 100px;
	right: 0px;
	border-radius: 6px 6px 0 0;
	transition: 1s cubic-bezier(0, 1, 0, 1) opacity;
	transform: rotate(-90deg);
	transform-origin: bottom right;
	${(props) =>
		props.open &&
		css`
			opacity: 0;
			pointer-events: none;
		`};
`;

export default function ConversationSidebar({
	conversation,
}: {
	conversation: graphql.Conversation;
}) {
	const { t } = useTranslation();
	const [opened, { open, close }] = useDisclosure(false);

	const useFeedback = useFeature(graphql.FeatureName.Feedback);
	const useGoals = useFeature(graphql.FeatureName.Goals);
	const useNotes = useFeature(graphql.FeatureName.Notes);
	const useCompliments = useFeature(graphql.FeatureName.Compliments);

	return (
		<>
			<SideFloatingButton
				open={opened}
				icon={
					<Box style={{ transform: 'rotate(90deg)' }}>
						<ChevronLeftIcon />
					</Box>
				}
				title={t('conversation.sidebar.context.openButton.title')}
				type="secondary"
				onClick={() => open()}
			/>
			<Drawer
				opened={opened}
				position="right"
				onClose={close}
				title={t('conversation.sidebar.context.title', {
					name: conversation.requester.firstName,
				})}
				overlayProps={{ backgroundOpacity: 0.5, blur: 1 }}
			>
				<SidebarConversationSection
					conversationID={conversation.id}
					userID={conversation.requester.id}
				/>
				{useGoals && <SidebarGoalsSection userID={conversation.requester.id} />}
				{useFeedback && <SidebarFeedbackSection userID={conversation.requester.id} />}
				{useCompliments && <SidebarComplimentSection userID={conversation.requester.id} />}
				{useNotes && (
					<SidebarNotesSection userID={conversation.requester.id} conversation={conversation} />
				)}
				<SidebarJobsSection user={conversation.requester} />
			</Drawer>
		</>
	);
}
